(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bolek-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bolek-signature'))customElements.define('bolek-signature',class extends HTMLElement{
connectedCallback(){
if(this.dataset.animate!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver'in window))return;
this.classList.add('signature-waiting');
this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.classList.remove('signature-waiting');this.observer.disconnect();}},{threshold:.2});
this.observer.observe(this);
}
disconnectedCallback(){this.observer?.disconnect();}
});

document.addEventListener('change', function(event) {
  if (!event.target.matches('[data-bk-preference]')) return;
  const phone = event.target.form.querySelector('[name="contact[phone]"]');
  const prefix = event.target.form.querySelector('[name="contact[Prefijo]"]');
  phone.required = event.target.value === 'Teléfono';
  prefix.required = phone.required || phone.value.length > 0;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bolek-original"]) return;
  try {
    
if(!customElements.get('bolek-photo-viewer'))customElements.define('bolek-photo-viewer',class extends HTMLElement{
connectedCallback(){
if(this.dataset.enabled!=='true'||this.bound)return;
this.dialog=this.querySelector('dialog');if(!this.dialog?.showModal)return;
this.bound=true;this.abort=new AbortController();const options={signal:this.abort.signal};
this.links=Array.from(this.querySelectorAll('.bo-photos a'));this.image=this.dialog.querySelector('img');this.view=this.querySelector('.bo-lightbox-view');this.zoom=this.querySelector('[data-photo-zoom]');
this.links.forEach((link,index)=>link.addEventListener('click',event=>{
if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
event.preventDefault();this.opener=link;this.index=index;this.showPhoto();this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.dialog.showModal();
},options));
this.querySelector('[data-photo-close]').addEventListener('click',()=>this.dialog.close(),options);
this.querySelector('[data-photo-prev]').addEventListener('click',()=>this.move(-1),options);
this.querySelector('[data-photo-next]').addEventListener('click',()=>this.move(1),options);
this.zoom.addEventListener('click',()=>{const active=this.view.classList.toggle('is-zoomed');this.zoom.setAttribute('aria-pressed',String(active));},options);
this.dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.move(event.key==='ArrowLeft'?-1:1);}},options);
this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},options);
this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';this.opener?.focus({preventScroll:true});},options);
}
move(step){this.index=(this.index+step+this.links.length)%this.links.length;this.showPhoto();}
showPhoto(){
const link=this.links[this.index],caption=link.closest('figure').querySelector('figcaption')?.textContent||'';
this.image.src=link.href;this.image.alt=link.querySelector('img')?.alt||caption;
this.querySelector('.bo-photo-caption').textContent=caption;
this.querySelector('.bo-photo-count').textContent=(this.index+1)+' / '+this.links.length;
this.view.classList.remove('is-zoomed');this.view.scrollTop=0;this.view.scrollLeft=0;this.zoom.setAttribute('aria-pressed','false');
this.querySelector('[data-photo-prev]').hidden=this.links.length<2;this.querySelector('[data-photo-next]').hidden=this.links.length<2;
}
disconnectedCallback(){if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.previousOverflow||'';}this.abort?.abort();this.bound=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
